<template>
  <div>
    <h1>Campaign attendance:</h1>
    <div>
      <ul>
        <li v-for="attendance in campaign_attendance">
          Took part in {{ attendance.campaign_name }}
          flying for {{ attendance.hist_unit_name }}
          ( {{ attendance.base_unit_name }} )</li>
      </ul>
    </div>


  </div>

</template>

<script>
import { mapState } from "vuex"

export default {
  name: "MemberCampaignAttendance",
  computed: {

    ...mapState("memberInfo", {

      campaign_attendance: state => state.member_campaign_attendance,
    }),

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/member/MemberCampaignAttendance.vue